import React from 'react';
import { ActivityIndicator, TextInput, TextInputProps, View } from 'react-native';

import { useThemePalette } from '../contexts/ThemePalette';
import { cn } from '../utils/cn';

import ThemedText from './ThemedText';

interface InputProps extends Omit<TextInputProps, 'style'> {
  label: string;
  error?: string;
  containerStyle?: any;
  loading?: boolean;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  containerStyle,
  loading = false,
  ...inputProps
}) => {
  const palette = useThemePalette();

  return (
    <View className='mb-6' style={containerStyle}>
      <ThemedText type='bodyRegular' className='mb-2 text-login-purple-90'>
        {label}
      </ThemedText>
      <View className='relative'>
        <TextInput
          className={cn(
            'w-full p-[14px] border rounded-lg text-base text-login-purple-90 bg-login-surface-pure font-login-body',
            error ? 'border-login-red-50' : 'border-login-gray-10'
          )}
          placeholderTextColor={palette.gray[30]}
          autoCapitalize='none'
          {...inputProps}
        />
        {loading && (
          <View className='absolute right-[14px] top-0 bottom-0 justify-center'>
            <ActivityIndicator size='small' color={palette.purple[50]} />
          </View>
        )}
      </View>
      {error && (
        <ThemedText type='bodySmall' className='text-login-red-50 mt-2'>
          {error}
        </ThemedText>
      )}
    </View>
  );
};
